"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageZQSC = void 0;
var react_1 = __importDefault(require("react"));
var crumbs_1 = require("../crumbs");
var mini_time_chart_1 = require("./shared/mini_time_chart");
var layout_1 = require("./shared/layout");
var title_1 = require("./shared/title");
var middle_1 = require("../quotetable/middle");
var title_quotetable_1 = require("./shared/title/title_quotetable");
/**
 * 债券市场
 * @returns
 */
function PageZQSC() {
    return (react_1.default.createElement("div", { className: "pagezqsc" },
        react_1.default.createElement(crumbs_1.CrumbsWithRefreshLine, null),
        react_1.default.createElement(layout_1.Layout3, { mt: 5 },
            react_1.default.createElement(layout_1.Layout3.Item, null,
                react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "1.000012", height: 162, width: 324, link: true }, "\u56FD\u503A\u6307\u6570")),
            react_1.default.createElement(layout_1.Layout3.Item, null,
                react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "1.000013", height: 162, width: 324, link: true }, "\u6CAA\u4F01\u503A\u6307\u6570")),
            react_1.default.createElement(layout_1.Layout3.Item, null,
                react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "0.399481", height: 162, width: 324, link: true }, "\u6DF1\u4F01\u503A\u6307\u6570"))),
        react_1.default.createElement(BlockTitle, { mt: 10, txt: "债券指数", link: "gridlist.html#bond_index" }),
        react_1.default.createElement(middle_1.QuoteTableMiddle, { fs: "i:1.000012,i:1.000013,i:1.000022,i:1.000061,i:0.395021,i:0.395022,i:0.395031,i:0.395032,i:0.399481",
            count: 5,
            table_key: 'ZQZS_HOME1',
            order: 'f3',
            orderdur: 1 }),
        react_1.default.createElement(middle_1.QuoteTableMiddleMore, null,
            react_1.default.createElement("a", { href: "gridlist.html#bond_index" }, "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u503A\u5238\u6307\u6570>>")),
        react_1.default.createElement(BlockTitle, { mt: 10, txt: "上海债券", link: "gridlist.html#bond_sh" }),
        react_1.default.createElement(layout_1.Layout3, { mt: 0 },
            react_1.default.createElement(layout_1.Layout3.Item, null,
                react_1.default.createElement(BlockTable, { tit: "\u6CAA\u56FD\u503A", link: "gridlist.html#bond_national_sh", fs: "m:1+b:MK0351", bmtxt: "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u6CAA\u56FD\u503A" })),
            react_1.default.createElement(layout_1.Layout3.Item, null,
                react_1.default.createElement(BlockTable, { tit: "\u6CAA\u4F01\u503A", link: "gridlist.html#bond_enterprise_sh", fs: "m:1+b:MK0353", bmtxt: "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u6CAA\u4F01\u503A" })),
            react_1.default.createElement(layout_1.Layout3.Item, null,
                react_1.default.createElement(BlockTable, { tit: "\u6CAA\u8F6C\u503A", link: "gridlist.html#bond_convertible_sh", fs: "m:1+b:MK0354", bmtxt: "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u6CAA\u8F6C\u503A" }))),
        react_1.default.createElement(BlockTitle, { mt: 10, txt: "深圳债券", link: "gridlist.html#bond_sz" }),
        react_1.default.createElement(layout_1.Layout3, { mt: 0 },
            react_1.default.createElement(layout_1.Layout3.Item, null,
                react_1.default.createElement(BlockTable, { tit: "\u6DF1\u56FD\u503A", link: "gridlist.html#bond_national_sz", fs: "m:0+b:MK0351", bmtxt: "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u6DF1\u56FD\u503A" })),
            react_1.default.createElement(layout_1.Layout3.Item, null,
                react_1.default.createElement(BlockTable, { tit: "\u6DF1\u4F01\u503A", link: "gridlist.html#bond_enterprise_sz", fs: "m:0+b:MK0353", bmtxt: "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u6DF1\u4F01\u503A" })),
            react_1.default.createElement(layout_1.Layout3.Item, null,
                react_1.default.createElement(BlockTable, { tit: "\u6DF1\u8F6C\u503A", link: "gridlist.html#bond_convertible_sz", fs: "m:0+b:MK0354", bmtxt: "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u6DF1\u8F6C\u503A" })))));
}
exports.PageZQSC = PageZQSC;
/**
 * 块级title
 * @param props
 * @returns
 */
function BlockTitle(props) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(title_1.Title1, { mt: props.mt },
            react_1.default.createElement(title_1.Title1.Main, null, props.txt),
            react_1.default.createElement(title_1.Title1.More, null,
                react_1.default.createElement("a", { href: props.link }, "\u66F4\u591A>>")))));
}
/**
 * layout3 子元素table模块
 * @param props
 * @returns
 */
function BlockTable(props) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(title_quotetable_1.Title1QuoteTable, { bottom_more: react_1.default.createElement("a", { href: props.link },
                props.bmtxt,
                ">>"), table_key: 'ZQZS_HOME2',
            fs: props.fs,
            count: 5,
            order: 'f3',
            orderdur: 1,
            xgtype: '' },
            react_1.default.createElement("a", { href: props.link, target: "_blank" }, props.tit))));
}
